import * as stylex from "@stylexjs/stylex";
import { colors, layoutAreas } from "../../materials/consts.stylex";
// Aside's `children` is MDX content — StyleX can't reach its `h4`/`p` elements or express
// the `& > * + *` / `& p + p` spacing rules directly, so they live in style.global.css,
// scoped by the `aside-content` marker class.
export const Aside = ({ children, mobilePlacement = "top" })=>{
    return <div className={`aside-content ${({
        0: {
            className: "x1i0bdlb x199luj4 x196nufh"
        },
        1: {
            className: "x1i0bdlb x199luj4 x196nufh xad2fwa"
        }
    })[!!(mobilePlacement === "top") << 0].className}`}>
      {children}
    </div>;
};
